module.exports = __webpack_public_path__ + "static/d05-afb038e480b6b0d820a6d80723a1090b.png";